import { IRootState, RootState } from '../root-state.store';
// @ts-ignore
import { IAuthorizationService } from '@/services';
import { ActivityStatus } from '../../common/enums';
import { AuthorizationService } from '../../services';
import { IUserDetails, UserDetails } from '../../models/user';

export interface IAuthorizationState extends IRootState<IAuthorizationService> {
  isAuthorized: boolean;

  signInPayload: {
    activityStatus: ActivityStatus,
    accessToken: string
    error: any | any | null
  }
}

export class AuthorizationState extends RootState<IAuthorizationService> implements IAuthorizationState {
  /**
   *
   */
  isAuthorized: boolean;
  signInPayload: {
    activityStatus: ActivityStatus,
    accessToken: string
    error: any | any | null
  }

  constructor() {
    super({
      activityStatus: ActivityStatus.NoActivity,
      service: new AuthorizationService
    });
    this.isAuthorized = false;

    this.signInPayload = {
      activityStatus: ActivityStatus.NoActivity,
      accessToken: localStorage.getItem('token'),
      error: null
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/authorization/authorization-state.store.ts